export const salutations = ['mr', 'mrs', 'miss', 'ms', 'dr']
export const residentialStatusCodes = ['HO', 'PT', 'CT', 'LP', 'O']
export const employmentStatusCodes = ['EM', 'SE', 'HO', 'RE', 'UN', 'ST']